import React from "react";
import ReactSelect from "react-select";
import { Form, Row, Modal, Button as ButtonBootstrap } from "react-bootstrap";
import { config } from "../../../../constants";
import CircleSign from "../../../ui/CircleSign";
import apiClient from '../../../../utils/apiClient';

const url = config.url.URL; //"http://localhost:52344";

const validationColor = {
  control: (styles) => ({
    ...styles,
    borderLeftColor: "red",
    borderLeftWidth: "4px",
    borderRadius: "0",
  }),
};

export default class UserRightsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: props.values ?? [],
      isMulti: props.isMulti ?? false,
      optionsSelected: [],
      idsSelected: props.idsSelected ?? null,
      Scopes: props.Scopes ?? [],
      RolesSelected: [],
      scopeId: props.scopeId ?? null,
      rightValidation: true,
      profileValidation: true,
      roleValidation: true,
    };
    this.UserRightsName = React.createRef();
    this.Profile = React.createRef();
    this.Role = React.createRef();
  }

  getValidation = () => {
    let rightVall = false;
    let profileVall = false;
    let roleVall = false;

    if (this.refs.UserRightsName.value == "") {
      this.setState({ rightValidation: false });
      rightVall = false;
    } else {
      this.setState({ rightValidation: true });
      rightVall = true;
    }

    if (this.refs.Profile.value == "") {
      this.setState({ profileValidation: false });
      profileVall = false;
    } else {
      this.setState({ profileValidation: true });
      profileVall = true;
    }

    if (this.state.optionsSelected.length == 0) {
      this.setState({ roleValidation: false });
      roleVall = false;
    } else {
      this.setState({ roleValidation: true });
      roleVall = true;
    }
    console.log(this.state.optionsSelected);
    let validation = {
      rightValidation: rightVall,
      profileValidation: profileVall,
      roleValidation: roleVall,
    };
    return validation;
  };

  getSelectedValues = () => {
    this.state.RolesSelected = [];
    if (this.state.optionsSelected != null) {
      this.state.optionsSelected.map((select) => {
        this.state.RolesSelected.push(`"${select.value}"`);
      });
    }
    return this.state.RolesSelected;
  };

  getSelectedOptions = () => {
    return this.state.optionsSelected;
  };

  handleChange = (selected) => {
    this.setState({
      optionsSelected: this.state.isMulti ? selected : Array.of(selected),
    });
  };

  setRoles() {
    if (this.state.idsSelected != null) {
      const filtered = this.state.values.filter((obj) => {
        return this.state.idsSelected.includes(obj.value);
      });

      this.setState({
        optionsSelected: filtered,
      });
    }
  }

  setProfile() {
    this.refs.Profile.value = this.state.scopeId;
  }

  fetchScopes() {
    let initialScopes = [];
    apiClient.get(`${url}/UserMicroservice/Scope`)
      .then((response) => {
        const data = response.data;
        this.state.Scopes = data;
        initialScopes = data;
        this.setState({
          Scopes: initialScopes,
        });
      });
  }

  fetchRoles() {
    apiClient.get(`${url}/RoleMicroservice`)
      .then((response) => {
        const data = response.data;
        let values = data.map((item) => {
          return {
            label: item.name,
            value: item.roleId,
          };
        });
        this.state.Roles = values;
        this.setState({ values: values });
      });
  }

  componentDidMount() {
    this.fetchScopes();
    this.fetchRoles();
    if (this.state.idsSelected != null) {
      const filtered = this.state.values.filter((obj) => {
        return this.state.idsSelected.includes(obj.value);
      });

      this.setState({
        optionsSelected: filtered,
      });
    }
  }

  render() {
    let l_Scopes = this.state.Scopes;
    let optionScopes = l_Scopes.map((Scope) => (
      <option value={Scope.scopeId}>{Scope.name}</option>
    ));

    return (
      <div>
        <Row className="mb-3">
          <Form.Group className="mb-3 col-md-4">
            <Form.Label
              className={`${
                this.state.rightValidation ? "normal-title" : "validation-title"
              }`}
            >
              User Rights Name <CircleSign />
            </Form.Label>
            <Form.Control
              className={`${
                !this.state.rightValidation && "validation-control"
              }`}
              type="text"
              ref="UserRightsName"
              placeholder="User Rights Name"
            />
            {!this.state.rightValidation && (
              <p className="p-required">Required</p>
            )}
          </Form.Group>

          <Form.Group className="mb-3 col-md-4">
            <Form.Label
              className={`${
                this.state.profileValidation
                  ? "normal-title"
                  : "validation-title"
              }`}
            >
              Profile <CircleSign />
            </Form.Label>
            <Form.Control
              className={`select-placeholder ${!this.state.profileValidation && "validation-control"}`}
              placeholder="Profile"
              ref="Profile"
              as="select"
              required
              defaultValue=""
            >
              <option value="" hidden>
                Profile
              </option>
              {optionScopes}
            </Form.Control>
            {!this.state.profileValidation && (
              <p className="p-required">Required</p>
            )}
          </Form.Group>

          <Form.Group className="mb-3 col-md-4">
            <Form.Label
              className={`${
                this.state.roleValidation ? "normal-title" : "validation-title"
              }`}
            >
              Role <CircleSign />
            </Form.Label>
            <ReactSelect
              ref="Role"
              options={this.state.values}
              isMulti={this.state.isMulti}
              styles={!this.state.roleValidation && validationColor}
              closeMenuOnSelect={!this.state.isMulti}
              onChange={this.handleChange}
              value={this.state.optionsSelected}
              className="custom-react-select" 
              classNamePrefix={"react-select"}
              placeholder="Role"
            />
            {!this.state.roleValidation && (
              <p className="p-required">Required</p>
            )}
          </Form.Group>
        </Row>
      </div>
    );
  }
}
